import { render, staticRenderFns } from "./DispatchLimitInput.vue?vue&type=template&id=01d8fb26&scoped=true"
import script from "./DispatchLimitInput.vue?vue&type=script&lang=js"
export * from "./DispatchLimitInput.vue?vue&type=script&lang=js"
import style0 from "./DispatchLimitInput.vue?vue&type=style&index=0&id=01d8fb26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8fb26",
  null
  
)

export default component.exports